module.exports = __webpack_public_path__ + "static/img/scan-code1.8bc5536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/scan-code1.png
// module id = wzEM
// module chunks = 1